import React, { Fragment } from 'react'
import { Route } from 'react-router-dom';
import { CheckRollSummaryReportListing } from './Pages'

export const CheckRollSummaryReportRoutes = ({ match }) => (
    <Fragment>
        <Route exact path={`${match.path}`} component={CheckRollSummaryReportListing} />
    </Fragment>
)